import { useRecoilValue } from "recoil";

import { accountAtom } from "../../atoms";

export const useAccount = () => useRecoilValue(accountAtom);

export enum Status {
  Disabled = "Disabled",
  Ready = "Undeployed",
  Enabled = "Deployed",
  Pending = "Pending",
  Error = "Error",
}

// const accountToStatus = ({
//   suppliedBalance,
//   deployedBalance,
//   pendingUnstakedBalance,
// }: ) => {
//   if (!pendingUnstakedBalance.isZero()) {
//     return Status.Pending
//   } else if (!deployedBalance.isZero()) {
//     return Status.Enabled
//   } else if (!suppliedBalance.isZero()) {
//     return Status.Ready
//   }
//   return Status.Disabled
// }

// export const useAccountStatus = () => {
//   const accountCtx = useAccountContext()
//   return accountToStatus(accountCtx)
// }
